import React, { useEffect } from 'react';
import 'twin.macro';
import { Icon } from '../icon';
import { TimesIcon } from 'icons';
import { ToastContainer, toast } from 'react-toastify';
import { injectStyle } from 'react-toastify/dist/inject-style';

const toastStyle = {
  position: 'relative',
  display: 'flex',
  padding: '0.5rem',
  borderRadius: '0.375rem',
  justifyContent: 'space-between',
  overflow: 'hidden',
  cursor: 'pointer',
  minHeight: '3rem',
  color: 'var(--toastify-text-color)',
  fontSize: '0.9rem',
  fontWeight: 'bold',
};

const notifyDefault = (label) =>
  toast(label, { style: { ...toastStyle, background: 'var(--toastify-color-default)' } });
const notifySuccess = (label) =>
  toast.success(label, { style: { ...toastStyle, background: 'var(--toastify-color-success)' } });
const notifyInfo = (label) =>
  toast.info(label, { style: { ...toastStyle, background: 'var(--toastify-color-info)' } });
const notifyWarning = (label) =>
  toast.warn(label, { style: { ...toastStyle, background: 'var(--toastify-color-warning)' } });
const notifyError = (error) =>
  toast.error(
    error
      ? error.response && error.response.data
        ? error.response.data.message
          ? error.response.data.message
          : error.response.data
        : error
      : 'er gaat iets mis',
    { style: { ...toastStyle, background: 'var(--toastify-color-error)' } },
  );

const CloseButton = ({ closeToast }) => (
  <Icon
    Type={TimesIcon}
    aria-hidden='true'
    tw='cursor-pointer hover:opacity-30'
    size='medium'
    onClick={closeToast}
    style={{ color: 'var(--toastify-text-color)' }}
  />
);

export const NotificationsContainer = () => {
  useEffect(() => {
    injectStyle();
  }, []);

  return (
    <ToastContainer
      position='bottom-center'
      autoClose={2500}
      hideProgressBar={false}
      newestOnTop={false}
      icon={false}
      rtl={false}
      stacked={false}
      pauseOnFocusLoss={false}
      closeOnClick
      draggable
      pauseOnHover
      theme='colored'
      closeButton={CloseButton}
    />
  );
};

export { notifyDefault, notifySuccess, notifyError, notifyWarning, notifyInfo };
